import {
    defaultBaseQuery,
    transformErrorResponse,
    transformRequest,
    transformSuccessResponse
} from '@/services';
import { createApi } from '@reduxjs/toolkit/query/react';

const studentRegistrationapi = createApi({
    reducerPath: "studentRegistrationapi",
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({

        studentBasicDetails: builder.mutation({
            query: (requestData) => ({
                url: `/sreg/student/register/basic-details`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        studentAddress: builder.mutation({
            query: (requestData) => ({
                url: `/sreg/student/register/address`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        studentAdmission: builder.mutation({
            query: (requestData) => ({
                url: `/sreg/student/register/admission`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        studentAcademics: builder.mutation({
            query: (requestData) => ({
                url: `/sreg/student/register/academics`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),

        getStudentAcademicInfo: builder.mutation({
            query: ({ skipErrorToast, ...requestData }) => ({
                url: "/sreg/student/profile/academic-details",
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        getStudentRegisterInfo: builder.query({
            query: () => ({
                url: `/sreg/student/register`,
                method: 'GET',
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        submitStudentInfo: builder.mutation({
            query: (requestData) => ({
                url: "/sreg/student/register",
                method: 'PUT',
                params: (requestData)

            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        }),
        studentAcademicSearch: builder.mutation({
            query: (requestData) => ({
                url: `/sreg/student/register`,
                method: 'POST',
                body: transformRequest(requestData),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse
        })
    }),
});

export const {
    useStudentBasicDetailsMutation, useStudentAddressMutation,
    useStudentAdmissionMutation, useStudentAcademicsMutation,
    useLazyGetStudentRegisterInfoQuery, useGetStudentAcademicInfoMutation,
    useSubmitStudentInfoMutation, 
    useStudentAcademicSearchMutation
} = studentRegistrationapi;

export default studentRegistrationapi;
